export default "__VITE_ASSET__D11RKzcb__"